import { OrderDetail, RepoType } from 'api'
import { compact } from 'lodash'
import { Selector, createSelector } from '@reduxjs/toolkit'
import {
  isTradingEntityInAuthorisedUserOrganisationSelector,
  isTradingEntityAssignedToAuthorisedUserSelector,
  createTradingEntityHasBuySideRelationshipWithFundsSelector,
  isTradingEntityTradable,
  tradingEntityHasRepoTypeSBLGetterSelector,
  createTradingEntityCanTradeCollateralBasketsSelector,
  createTradingEntityCanTradeCollaterals
} from './tradingEntityFilterSelectors'

export const createTradingEntityFiltersForStagingMyEntitySelector = <P>(orderDetailSelector: Selector<{}, OrderDetail, [P]>) =>
  createSelector(
    [
      orderDetailSelector,
      isTradingEntityInAuthorisedUserOrganisationSelector,
      isTradingEntityAssignedToAuthorisedUserSelector,
      createTradingEntityHasBuySideRelationshipWithFundsSelector,
      tradingEntityHasRepoTypeSBLGetterSelector,
      createTradingEntityCanTradeCollateralBasketsSelector
    ],
    (
      { collateral, collateralBasket, counterpartyIds, secondaryCollateralBasket, secondaryCollateral, order },

      isTradingEntityInAuthorisedUserOrganisation,
      isTradingEntityAssignedToAuthorisedUserSelector,
      createTradingEntityHasBuySideRelationshipWithFunds,
      tradingEntityHasRepoTypeSBL,
      createTradingEntityCanTradeCollateralBaskets
    ) => {
      const marketType = order.marketType

      return compact([
        isTradingEntityInAuthorisedUserOrganisation,
        isTradingEntityAssignedToAuthorisedUserSelector,
        isTradingEntityTradable,
        collateral && createTradingEntityCanTradeCollaterals([{ collateral, marketType }]),
        collateralBasket && createTradingEntityCanTradeCollateralBaskets([{ collateralBasket, marketType }]),
        secondaryCollateral && createTradingEntityCanTradeCollaterals([{ collateral: secondaryCollateral, marketType }]),
        secondaryCollateralBasket &&
          createTradingEntityCanTradeCollateralBaskets([{ collateralBasket: secondaryCollateralBasket, marketType }]),
        createTradingEntityHasBuySideRelationshipWithFunds(counterpartyIds),
        order.repoType === RepoType.STOCK_BORROWING_LENDING && tradingEntityHasRepoTypeSBL
      ])
    }
  )
